import constructorfleetTokens from "./branding.tokens.json";

type TokenLeaf = {
  value: string | number;
};

type RawTokenValue<T> = T extends TokenLeaf
  ? T["value"]
  : T extends readonly unknown[]
    ? { readonly [K in keyof T]: RawTokenValue<T[K]> }
    : T extends Record<string, unknown>
      ? { readonly [K in keyof T]: RawTokenValue<T[K]> }
      : T;

function unwrapTokenValues<T>(input: T): RawTokenValue<T> {
  if (Array.isArray(input)) {
    return input.map((value) => unwrapTokenValues(value)) as RawTokenValue<T>;
  }

  if (input && typeof input === "object") {
    const entries = Object.entries(input);

    if (entries.length === 1 && entries[0]?.[0] === "value") {
      return entries[0][1] as RawTokenValue<T>;
    }

    return Object.fromEntries(
      entries.map(([key, value]) => [key, unwrapTokenValues(value)])
    ) as RawTokenValue<T>;
  }

  return input as RawTokenValue<T>;
}

export const cfRawTokens = unwrapTokenValues(constructorfleetTokens);

export type CFRawTokens = typeof cfRawTokens;
